import { Component, OnInit } from '@angular/core';
import { PushNotificationsService } from 'ng-push';
import { AppService } from './shared/services';
import { AppSetting } from './shared/services/appsetting';
import { Router } from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase';
import { take } from 'rxjs/operators';
@Component({
    selector: 'e-company-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    responseData: any;
    pushData: any;
    user: any;
    appointmentMsg: any;
    isLoader: boolean = false;
    permission: string;
    messaging = firebase.messaging()
    currentMessage = new BehaviorSubject(null)

    // angularFireMessaging=firebase.messaging(this._firebaseApp);
    //   currentMessage = new BehaviorSubject(null)
    constructor(
        private _pushNotifications: PushNotificationsService,
        private appService: AppService,
        public router: Router,
        private db: AngularFireDatabase, private afAuth: AngularFireAuth

    ) {

    }
    goServiceDetailPage() {
        this.router.navigate(['/dashboard']);
        if (localStorage.getItem('userData')) {
        }
    };
    create(title: string, appointment_code: string, options?: NotificationOptions, router?: any): any {
        let self = this;
        return new Observable(function (obs) {
            if (!('Notification' in window)) {
                console.log('Notifications are not available in this environment');
                obs.complete();
            }
            if (self.permission !== 'granted') {
                console.log("The user hasn't granted you permission to send push notifications");
                obs.complete();
            }
            // options.event.action = function(){

            // };
            let _notify = new Notification(title, options);
            _notify.onshow = function (e) {
                return obs.next({
                    notification: _notify,
                    event: e
                });
            };

            _notify.onclick = function (e) {
                console.log("click push notifications");
                console.log(appointment_code);
                console.log("/appointment/form?ac=APC20190904104349707250");
                if (!localStorage.getItem('userData')) {
                    router.navigate(['/login'], { queryParams: { ac: appointment_code } })
                } else {
                    router.navigate(['/appointment/form'], { queryParams: { ac: appointment_code } })
                }
                //   router.navigate(['/appointment/form?ac=123'])

                // t.goServiceDetailPage();
                //  obs.next({
                //     notification: "asdfasd",
                //     event: function(){
                //         this.goServiceDetailPage();
                //         console.log("click push notifications 2");
                //     }
                // });
            };
            _notify.onerror = function (e) {
                return obs.error({
                    notification: _notify,
                    event: e
                });
            };
            _notify.onclose = function () {
                return obs.complete();
            };
        });
    }

    notify(title, msg, icon, appointment_code) { //our function to be called on click
        let options = { //set options

            body: msg,
            icon: icon,//"assets/images/ontdc.png", //adding an icon
            //  click_action: click_act,

        }
        let notify = this.create(title, appointment_code, options, this.router).subscribe();
    }

    ngOnInit() {
        console.log("AAkash 1");
        this.getPermission()
        this.receiveMessage();
        // this.route.params.subscribe(params => {
        // )
        // this.isLoader = true;
        // let fd: FormData = new FormData();
        // let ad = {
        //     action: AppSetting.API_ACTION.GET_NEW_APPOINTMENT_COUNT
        // }
        // this.appService.httpCall(ad, fd).subscribe(result => {
        //     this.responseData = result;
        //     console.log(this.responseData);
        //     this.isLoader = false;
        //     this.appointmentMsg = this.responseData.responseData.appointmentMsg;
        //     this.notify("Appointment", this.appointmentMsg);

        // }, error => {
        //     this.isLoader = false;
        // });


    }
    updateTokenOnServer(token) {


        if (localStorage.getItem('userData')) {

            this.isLoader = true;
            this.user = JSON.parse(localStorage.getItem('userData'));
            console.log(this.user);
            console.log(this.user.user_code);
            let fd: FormData = new FormData();
            fd.append('user_code', this.user.user_code);
            fd.append('token', token);

            let ad = {
                action: AppSetting.API_ACTION.UPDATE_WEB_PUSH_TOKEN
            }
            this.appService.httpCall(ad, fd).subscribe(result => {
                this.responseData = result;
                console.log(this.responseData);
                this.isLoader = false;
                console.log(this.responseData.message);

            }, error => {
                this.isLoader = false;
            });
        }


    }
    updateToken(token) {
        this.afAuth.authState.take(1).subscribe(user => {
            if (!user) return;

            const data = { [user.uid]: token }
            this.db.object('fcmTokens/').update(data)
        })
    }

    getPermission() {
        this.messaging.requestPermission()
            .then(() => {
                console.log('Notification permission granted.');
                return this.messaging.getToken()
            })
            .then(token => {
                console.log(token)
                localStorage.setItem('push_token', token);
                this.updateTokenOnServer(token);
                this.updateToken(token)
            })
            .catch((err) => {
                console.log('Unable to get permission to notify.', err);
            });
    }

    receiveMessage() {

        this.messaging.onMessage((payload) => {
            console.log("Message received. ", payload);
            this.pushData = payload;
            this.notify(this.pushData.notification.title, this.pushData.notification.body, this.pushData.data.icon, this.pushData.data.appointment_code);
            this.currentMessage.next(payload)
        });

    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2455195120/src/src/app/app.component.ts